import { selectFeatureFlag } from 'global/openpathconfig/selectors';
import { useSelectorJs } from 'utils/customHooks';
import { useUrlSearchParams } from 'utils/customHooks/useUrlSearchParams';

export const useIsSso = () => {
  const { sso } = useUrlSearchParams();
  const isSso = sso === 'true';

  const enabledFeatureCodes = useSelectorJs(
    selectFeatureFlag('ENABLED_FEATURE_CODES'),
  );

  const isSsoEnabled =
    enabledFeatureCodes.includes('samlSso') &&
    enabledFeatureCodes.includes('samlJit');

  return isSso && isSsoEnabled;
};
